import styled from 'styled-components'

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.medium};
  padding: 0px ${({ theme }) => theme.spacing.large};
`

export const SectionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: ${({ theme }) => theme.spacing.small};
`

export const SectionTitle = styled.h4`
  font-size: ${({ theme }) => theme.typography.fontSize.section};
  font-weight: ${({ theme }) => theme.typography.fontWeight.semibold};
  color: ${({ theme }) => theme.colors.text.primary};
  margin: 0;
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.small};
`

export const ButtonGroup = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.small};
  align-items: center;
`

// Clean table with minimal styling
export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  background: ${({ theme }) => theme.colors.background.primary};
  border: 1px solid ${({ theme }) => theme.colors.border.light};
  border-top: none;
  border-radius: ${({ theme }) =>
    `0 0 ${theme.borderRadius.medium} ${theme.borderRadius.medium}`};
  overflow: hidden;
`

export const TableHead = styled.thead`
  th {
    padding: ${({ theme }) => `${theme.spacing.small} ${theme.spacing.medium}`};
    text-align: left;
    font-weight: ${({ theme }) => theme.typography.fontWeight.semibold};
    color: ${({ theme }) => theme.colors.text.tertiary};
    font-size: ${({ theme }) => theme.typography.fontSize.small};
    text-transform: uppercase;
    letter-spacing: 0.5px;
    border-bottom: 1px solid ${({ theme }) => theme.colors.border.light};
    background: ${({ theme }) => theme.colors.background.primary};

    &:nth-child(2),
    &:nth-child(3),
    &:nth-child(4) {
      text-align: center;
      width: 150px;
    }
  }
`

export const TableBody = styled.tbody`
  td {
    padding: ${({ theme }) =>
      `${theme.spacing.xsmall} ${theme.spacing.medium}`};
  }

  tr:hover {
    background: ${({ theme }) => `${theme.colors.background.secondary}20`};
  }
`

export const MetricLabel = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  color: ${({ theme }) => theme.colors.text.primary};
  font-weight: ${({ theme }) => theme.typography.fontWeight.medium};
`

export const MetricValueCell = styled.td`
  text-align: center;
  font-weight: ${({ theme }) => theme.typography.fontWeight.medium};
  color: ${({ theme }) => theme.colors.text.primary};
`

export const EmptyValue = styled.span`
  color: ${({ theme }) => theme.colors.text.tertiary};
  font-style: italic;
  padding-top: ${({ theme }) => theme.spacing.small};
`

export const DifferenceCell = styled.td<{ $isPositive: boolean }>`
  text-align: center;
  font-weight: ${({ theme }) => theme.typography.fontWeight.semibold};
  color: ${({ $isPositive, theme }) =>
    $isPositive ? theme.colors.success : theme.colors.danger};
`

export const AuthorizedValue = styled.div<{
  $isEstimate?: boolean
  $source?: string
  $isUserEdited?: boolean
  $isPending?: boolean
}>`
  font-weight: ${({ theme }) => theme.typography.fontWeight.medium};
  color: ${({ $isEstimate, theme }) =>
    $isEstimate ? theme.colors.warning : theme.colors.text.primary};
  cursor: pointer;
  text-decoration: underline;
  text-decoration-style: dotted;
  text-decoration-color: ${({ theme }) => theme.colors.border.default};

  &:hover {
    text-decoration-style: solid;
    text-decoration-color: ${({ theme }) => theme.colors.primary};
  }
`
